// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let ImageUtils = require("../../../reason/common/imageUtils/ImageUtils.bs.js");
let ReasonPromise = require("../../../reason/ReasonPromise.bs.js");
let ReactImageCrop = require("../../bindings/ReactImageCrop.bs.js");
let Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function makeInitialCrop(image) {
  let width = image.naturalWidth;
  let height = image.naturalHeight;
  return ReactImageCrop.centerCrop(ReactImageCrop.makeAspectCrop({
    unit: "%",
    x: 0,
    y: 0,
    width: 80,
    height: 0
  }, 1.0, width, height), width, height);
}

function CropProfilePhoto(props) {
  let onCropURLChange = props.onCropURLChange;
  let imageURL = props.imageURL;
  let match = React.useState(() => {});
  let setCrop = match[1];
  let match$1 = React.useState(() => {});
  let setCropURL = match$1[1];
  let cropURL = match$1[0];
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ReactImageCrop.make, {
      crop: match[0],
      aspect: 1.0,
      onChange: (param, pctCrop) => setCrop(param => pctCrop),
      onComplete: (param, pctCrop) => {
        setCrop(param => pctCrop);
        ReasonPromise.getOk(Utils__Promise.fromJsPromise(ImageUtils.getCroppedImage(imageURL, pctCrop)), dataUrl => {
          setCropURL(param => dataUrl);
          onCropURLChange(dataUrl);
          if (cropURL !== undefined) {
            URL.revokeObjectURL(cropURL);
            return;
          }
        });
      },
      minWidth: 20,
      minHeight: 20,
      keepSelection: true,
      circularCrop: true,
      className: "max-h-[450px]",
      children: JsxRuntime.jsx("img", {
        alt: "Crop your profile photo",
        src: imageURL,
        onLoad: event => {
          let crop = makeInitialCrop(event.currentTarget);
          setCrop(param => crop);
        }
      })
    }),
    className: "flex items-center justify-center max-h-[520px] bg-zinc-200"
  });
}

let cropAspect = 1.0;

let initialWidthPercent = 80;

let make = CropProfilePhoto;

exports.cropAspect = cropAspect;
exports.initialWidthPercent = initialWidthPercent;
exports.makeInitialCrop = makeInitialCrop;
exports.make = make;
/* react Not a pure module */
